import { useMemo } from 'react';

import { getTextFieldDefaultProps } from '../../utils/TextFieldUtils';
import { CustomTextField } from '../CustomTextField';

export default function CustomTextArea(props: any) {
  const p = useMemo(() => {
    return {
      ...getTextFieldDefaultProps(),
      ...props,
      multiline: true,
      maxRows: props.maxRows || 4,
      minRows: props.minRows || 1,
    } as any;
  }, [props]);

  return <CustomTextField {...p}>{props.children}</CustomTextField>;
}
